import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { ROUTES } from '@/AppRoutes';
import { useGetStudentProfile, useResetApp } from '@/hooks/api/useAtHomeAuth';
import useSendEvents from '@/hooks/util/useSendEvents';
import { AtHomeLoginResponse, GenericApiResponse, ResetAppResponse } from '@/services/api';
import { isApiResponseSuccess } from '@/utils/helper';

const useProfileScreen = () => {
  const { data: studentProfileData } = useGetStudentProfile();
  const navigate = useNavigate();
  const { appResetEvent } = useSendEvents();

  const { mutate: resetApp } = useResetApp({
    onSuccess: (payload: GenericApiResponse<ResetAppResponse>) => {
      if (payload && isApiResponseSuccess(payload)) {
        appResetEvent('Home');
        const deviceId = localStorage.getItem('device-id');
        localStorage.clear();
        sessionStorage.clear();
        navigate(ROUTES.ROOT);
        if (deviceId) {
          localStorage.setItem('device-id', deviceId);
        } else {
          const newDeviceId = uuidv4();
          localStorage.setItem('device-id', newDeviceId);
        }
      }
    },
  });

  const onResetApp = () => {
    const response = localStorage.getItem('atHomeLoginResponse') || '';
    const atHomeLoginResponse = JSON.parse(response) as AtHomeLoginResponse;
    const refreshToken = atHomeLoginResponse?.refreshToken;
    if (refreshToken) {
      resetApp({ refreshToken });
    }
  };
  return {
    studentProfileData,
    onResetApp,
  };
};

export default useProfileScreen;
